/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadDefinitionListRequest {
    getFixupPrototypeFunction() { return WorkloadDefinitionListRequest.fixupPrototype; }

    static newInstance(model: Partial<WorkloadDefinitionListRequest>): WorkloadDefinitionListRequest {
        let obj = Object.assign(new WorkloadDefinitionListRequest(), model);
        WorkloadDefinitionListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadDefinitionListRequest>): WorkloadDefinitionListRequest {
        if (!model) return null;
        return WorkloadDefinitionListRequest.newInstance(<WorkloadDefinitionListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadDefinitionListRequest) {
        if (!obj) return;

        models.WorkloadDefinitionListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadDefinitionListRequest): boolean {
        Object.setPrototypeOf(obj, WorkloadDefinitionListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.WorkloadFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.WorkloadDefinitionListSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.WorkloadDefinitionListSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.WorkloadFilter;

}
